/**
 * Melding når kunden har reservert seg mot e-post. Nevner kun SMS som sendt når tilbudet faktisk har SMS som kanal.
 */
export function emailUnsubscribedMessage(sentBySms: boolean): string {
	return sentBySms
		? "Kunden har reservert seg mot e-post, så bestillingslenken ble kun sendt på SMS."
		: "Kunden har reservert seg mot e-post, så bestillingslenken ble ikke sendt. Opprett et nytt tilbud med «Send på SMS» valgt, eller kontakt kunden.";
}
